import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { usePageNameContext } from "../../contexts/PageTitleContext";
import WorkOrderStats from "../../components/workOrders/WorkOrderStats";
import WorkOrdersTable from "../../components/workOrders/WorkOrdersTable";

export default function WorkOrders() {
  const { t } = useTranslation("workOrders");
  const { setInfo } = usePageNameContext();

  useEffect(() => {
    setInfo({
      name: t("Work Orders"),
      desc: t("Create and manage work orders for your team"),
    });
  }, [t]);

  return (
    <>
      <WorkOrderStats />
      <WorkOrdersTable />
    </>
  );
}
